import MidiEffect from './MidiEffect.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import Tone from 'tone';

class TimingEffect extends MidiEffect {
    constructor(track) {
        super('Timing', track);

        // timing offset 
        this.oddOffsetParameter = new AbstractParameter(
            'oddTiming', this, (o, x) => x,
            {
                documentation: "The delay amount (in 1/32th notes) for even-triggers (according to the resolution)",
                min: 0,
                max: 4,
                unit: '1/32th',
                defaultValue: 0,
            });
        this.registerParameter(this.oddOffsetParameter);

        // timing offset 
        this.evenOffsetParameter = new AbstractParameter(
            'evenTiming', this, (o, x) => x,
            {
                documentation: "The delay amount (in 1/32th notes) for odd-triggers (according to the resolution)",
                min: 0,
                max: 4,
                unit: '1/32th',
                defaultValue: 0
            });
        this.registerParameter(this.evenOffsetParameter);

        // parameters for the arpeggiator
        this.probabilityParameter = new AbstractParameter(
            'probability', this, (o, x) => x,
            {
                documentation: "The probability that this effect will occur on a given trigger.",
                min: 0,
                max: 100,
                unit: '',
                defaultValue: 100
            });
        this.registerParameter(this.probabilityParameter);

        // parameters for the arpeggiator
        this.resolutionParameter = new AbstractParameter(
            'resolution', this, (o, x) => x,
            {
                min: 1,

                max: 32,
                unit: '',
                defaultValue: 2,
            });
        this.registerParameter(this.resolutionParameter);
    }

    getVisualizedParameters() {
        return [this.oddOffsetParameter, this.evenOffsetParameter];
    }

    getText() {
        return this.resolution.toString() + ' ' + this.evenOffset + ', ' + this.oddOffset;
    }

    get documentation() {
        return "Controls the swing of a track by dividing triggers by a resolution and delaying them seperately";
    }

    getCopy(track, ignoreId=true) {
        let fx = new TimingEffect(track);
        fx.fromJson(this.getJson());
        return fx;
    }

    needsStableLookAhead() {
        return true;
    }

    get oddOffset() {
        return this.oddOffsetParameter.get();
    }

    set oddOffset(x) {
        this.oddOffsetParameter.set(x);
    }

    get evenOffset() {
        return this.evenOffsetParameter.get();
    }

    set evenOffset(x) {
        this.evenOffsetParameter.set(x);
    }


    set probability(x) {
        this.probabilityParameter.set(x);
    }

    get probability() {
        return this.probabilityParameter.get();
    }

    get resolution() {
        return this.resolutionParameter.get();
    }

    set resolution(r) {
        return this.resolutionParameter.set(r);
    }

    output() {
        for (let i in this.triggers) {
            let trigger = this.triggers[i];
            let time = trigger.time;

            let rand = Math.random();
            if (rand <= this.probability / 100.0) {
                // change the timing if the probability coin flip is "heads"
                let offset = Math.floor(trigger.stepNumber / this.resolution) % 2 == 0 ?
                    this.evenOffset : this.oddOffset;
                trigger.time = time +
                    (offset* new Tone.Time('32n').toMilliseconds()) / 1000.0;
            }
        }

        return this.triggers;
    }

    getCopy(track, ignoreId=true) {
        let effect = new TimingEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }
}

export default TimingEffect;
